var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConciliation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8008 5.4668V30.1335",
    stroke: "#4D2323",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1328 17.8L5.46614 17.8",
    stroke: "#4D2323",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5215 9.08008L9.07952 26.522",
    stroke: "#4D2323",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5215 26.52L9.07952 9.07805",
    stroke: "#4D2323",
    strokeWidth: 2.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    stroke: "#B7B7B7",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConciliation);
export default __webpack_public_path__ + "static/media/Conciliation.2e0c9a236c42cec92ab5b43a45d5ae6f.svg";
export { ForwardRef as ReactComponent };